export default function bgKey(key:any) {
    //console.log(key);
    return { type: "CURRENT_CATEG", payload: key };
  }